module.exports = __webpack_public_path__ + "img/logo.6c24b75c.png";